<template>
  <router-view />
  <CrosschainBuyRoot v-if="$route.name !== 'PhantomCallback'" />
</template>

<script setup lang="ts">
// Root App component - main entry point with router
import { CrosschainBuyRoot } from '@/features/crosschain-buy'
import { useTonWalletAppBindings } from '@/features/ton-wallet'
import { useGameSessionBindings } from '@/composables/useGameSessionBindings'

useTonWalletAppBindings()
useGameSessionBindings()
</script>
